import Editor from './Editor';
import './style';

export default Editor;
